import { ButtonHTMLAttributes } from 'react';
import styled, { DefaultTheme } from 'styled-components';

export interface IStyledButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof DefaultTheme['button'];
  outline?: boolean;
  dense?: boolean;
  fullWidth?: boolean;
  /** Margin top */
  mt?: number | 'auto';
  /** Margin right */
  mr?: number | 'auto';
  /** Margin bottom */
  mb?: number | 'auto';
  /** Margin left */
  ml?: number | 'auto';
}

export const StyledButton = styled.button<IStyledButton>`
  font-size: 0.875rem;
  font-weight: 700;
  padding: ${({ dense }) => (dense ? '0rem 0.3rem' : '0.5rem 1.5rem')};
  min-width: ${({ fullWidth }) => (fullWidth ? '0rem' : '8rem')};
  width: ${({ fullWidth }) => fullWidth && '100%'};
  border-radius: 4px;
  background-color: ${({ theme, variant = 'primary', outline }) =>
    outline ? 'transparent' : theme.button[variant].background};
  box-shadow: ${({ theme, variant = 'primary' }) => theme.button?.[variant]?.shadow};
  color: ${({ theme, variant = 'primary', outline }) =>
    outline ? theme.button[variant].outline.color : theme.button[variant].color};
  transition: filter 0.3s;
  display: flex;
  align-items: center;
  height: 42px;
  line-height: ${({ dense }) => dense && '1rem'};
  justify-content: center;
  margin-top: ${({ mt }) => (typeof mt === 'number' ? `${mt}rem` : mt)};
  margin-right: ${({ mr }) => (typeof mr === 'number' ? `${mr}rem` : mr)};
  margin-bottom: ${({ mb }) => (typeof mb === 'number' ? `${mb}rem` : mb)};
  margin-left: ${({ ml }) => (typeof ml === 'number' ? `${ml}rem` : ml)};

  border: ${({ theme, variant = 'primary', outline }) =>
    outline && `2px solid ${theme.button[variant].outline.border}`};
  transition: all ease-in 100ms;
  circle:last-child {
    stroke: ${({ theme, variant = 'primary', outline }) =>
      outline ? theme.button[variant].outline.color : theme.button[variant].color};
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:hover {
    filter: brightness(90%);
    opacity: 0.8;
  }

  &:active {
    filter: brightness(80%);
    opacity: 0.6;
  }
`;

export const LeftIconContainer = styled.div`
  margin-right: 0.5rem;
  margin-left: -1rem;
`;

export const RightIconContainer = styled.div`
  margin-left: 0.5rem;
  margin-right: -1rem;
`;
